import React, { FormEvent, useState } from "react";
import encodeAndSanitizeSearchQuery from "~/common/helpers/encodeAndSanitizeSearchQuery";

type Props = {
  searchTermDefault?: string;
};

function FoodServiceResourcesSearch({ searchTermDefault }: Props) {
  const [searchTerm, setSearchTerm] = useState(searchTermDefault ?? "");

  const onSearchTermChange = (event: FormEvent<HTMLInputElement>) => {
    setSearchTerm(event.currentTarget.value);
  };

  const onSubmitSearch = (event: FormEvent) => {
    event.preventDefault();

    const term = encodeAndSanitizeSearchQuery(searchTerm);

    if (term.length > 0) {
      window.location.href = `/food-service-resources/search/${term}/`;
    }
  };

  return (
    <div data-module="foodServiceResourcesSearch">
      <div className="fsr-search">
        <form id="searchWithinForm" onSubmit={onSubmitSearch}>
          <input
            type="text"
            name="searchTerm"
            data-testid="searchResources"
            placeholder="Search Resources"
            value={searchTerm}
            defaultValue={searchTerm}
            onChange={onSearchTermChange}
            aria-label="search resources"
          />
          <input
            type="submit"
            value="Go"
            className="btn btn-light btn-mini icon-search"
          />
          <button
            className="btn btn-light btn-mini h-[39px]"
            data-testid="searchBtn"
            type="submit"
            aria-label="search"
          >
            <i className="icon-search" />
          </button>
        </form>
      </div>
    </div>
  );
}

export default FoodServiceResourcesSearch;
